import { SupabaseClient } from '@supabase/supabase-js'
import {
  Row,
  TUserKnowledgeTestSelectKey,
  TUserKycSelectKey,
  TUserSuitabilityTestSelectKey,
  TUserVerificationDetailsSelectKey
} from './supabase.interface'

export async function getUserVerificationDetailsWithRelatedData(
  db: SupabaseClient,
  userId: string
): Promise<TUserVerificationDetailsSelectKey[]> {
  const { data, error } = await db
    .from('UserVerificationDetails')
    .select(
      `
      current_aml_id,
      current_knowledge_test_id,
      current_suitability_test_id,
      current_kyc_id,
      status,
      user_id
    `
    )
    .eq('user_id', userId)
    .is('deleted_at', null)
    .limit(1)

  if (error) {
    console.error('Error fetching data', error)
    return []
  }

  return data ?? []
}

export async function getUserSuitabilityTest(
  db: SupabaseClient,
  suitTestId: string | null
): Promise<TUserSuitabilityTestSelectKey[]> {
  const { data, error } = await db
    .from('UserSuitabilityTest')
    .select(
      `
      id,
      total_score,
      status,
      user_id
    `
    )
    .eq('id', suitTestId)
    .is('deleted_at', null)
    .limit(1)

  if (error) {
    console.error('Error fetching data', error)
    return []
  }

  return data
}

export async function getUserKnowledgeTest(
  db: SupabaseClient,
  knowledgeTestId: string | null
): Promise<TUserKnowledgeTestSelectKey[]> {
  const { data, error } = await db
    .from('UserKnowledgeTest')
    .select(
      `
      id,
      total_score,
      status,
      user_id
    `
    )
    .eq('id', knowledgeTestId)
    .is('deleted_at', null)
    .limit(1)

  if (error) {
    console.error('Error fetching data', error)
    return []
  }

  return data
}

export async function getUserKyc(
  db: SupabaseClient,
  kycId: string | null
): Promise<TUserKycSelectKey[]> {
  const { data, error } = await db
    .from('UserKyc')
    .select(
      `
      id,
      status,
      provider_status,
      user_id,
      identification_card_picture,
      selfie_picture,
      first_name,
      first_name_in_thai,
      middle_name,
      middle_name_in_thai,
      last_name,
      last_name_in_thai,
      metadata
    `
    )
    .eq('id', kycId)
    .is('deleted_at', null)
    .limit(1)

  if (error) {
    console.error('Error fetching data', error)
    return []
  }

  return data
}
